import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import projectCreate from 'containers/ProjectCreatePage/reducer'
import app from 'containers/App/App/reducer'
import { uiStateReducer as projectSearch } from 'containers/Project/Search/reducer'
import { uiStateReducer as productSearch } from 'containers/ProductSearchPage/reducer'
import { projectUiReducer as project } from 'containers/Project/reducer'
import { approvalUiReducer as approvals } from 'containers/Approval/reducer'
import { filterUiReducer as specFilter } from 'containers/Project/Specifications/reducers'
import {
  CLEAR_UI_FORM_ELEMENTS,
} from './constant'

const clearUiFormElementsReducer = (values, action) => {
  return {}
}
const formElements = createReducer({}, {
  [CLEAR_UI_FORM_ELEMENTS]: clearUiFormElementsReducer,
})
const reducers = combineReducers({
  formElements,
  projectCreate,
  productSearch,
  projectSearch,
  project,
  app,
  approvals,
  specFilter,
})
export default reducers
